<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="isShowResellerOrganizations ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!-------------------------------------- Table Content -------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- reseller -->
        <td>
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.userName"
          ></td-value>
        </td>

        <!-- organizationName -->
        <td>
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.organizationName"
          ></td-value>
        </td>

        <!-- panelPercent -->
        <td class="tw-px-1">
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.panelPercent"
          ></td-value>
          <span class="2px">%</span>
        </td>

        <!-- pricePerSms -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.pricePerSms"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!-- expireDate -->
        <td>
          <td-value type="date" [value]="item?.expireDate"></td-value>
        </td>

        <!---------------------------------- operations ---------------------------------->
        <td class="sticky-td">
          <div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- edit button -->
            <div app-menu-btn icon="edit" (click)="onUpdate(item.id)"></div>

            <!-- organizations button -->
            <!-- <div mat-menu-item class="tw-flex-center text-info border-bottom" (click)="onShowResellerOrganizations(item.userId)">
              <i class="mdi mdi-table-network mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-info"></i>
              <span class="mat-menu-title tw-font-medium ">{{'common.organizations' | translate}}</span>
            </div> -->

            <!-- delete button -->
            <div app-menu-btn icon="delete" (click)="onDelete(item.id, item?.userName)"></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- add or update form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-resellers-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-resellers-form>
</ng-container>

<!-- reseller organizations -->
<!-- <ng-container *ngIf="isShowResellerOrganizations">
<app-reseller-organizations [items]="resellersOrganizations$" [userId]="resellerUserIdSelected"
  (onBack)="isShowResellerOrganizations=false">
</app-reseller-organizations>
</ng-container> -->
<!---------------------------------------- Audit --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!---------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
